import {Preferences} from './preferences.js';
import {Names} from './names.js';
import {Addresses} from './addresses.js';
import {PhoneNumbers} from './phoneNumbers.js';
import {TermsAndConditions} from './termsAndConditions.js';
import {LegalID} from './legalId.js';

export var Person = function(personData) {
    var person = {};
    var legalIDs = [];

    // Constructor
    if (personData) {
        person.id = personData.id;
        person.email = personData.email;
        person.country = personData.country;
        person.type = personData.type;
        person.personFromAccount = personData.personFromAccount;
        person.accountID = personData.accountID;
        person.inviterID = personData.inviterID;
        person.fID = personData.fID;
        person.preferredLanguage = personData.preferredLanguage;
        person.birthDate = personData.birthDate;
        person.gender = personData.gender;
        person.profilePictureUrl = personData.profilePictureUrl;
        person.profileThumbnailUrl = personData.profileThumbnailUrl;
        person.preferredName = personData.preferredName;

        person.preferences = Preferences(personData.preferences);
        person.names = Names(personData.names);
        person.addresses = Addresses(personData.addresses);
        person.phoneNumbers = PhoneNumbers(personData.phoneNumbers);
        person.termsAndConditions = TermsAndConditions(personData.termsAndConditions);

        person.legalIDs = legalIDs;
        if (personData.legalIDs) {
            for (var i=0; i<personData.legalIDs.length; i++) {
                legalIDs.push(LegalID(personData.legalIDs[i]));
            }
        }
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    person.getSSN = function() {
        return getLegalIDListItem('SSN');
    };

    person.getTax1 = function() {
        return getLegalIDListItem('TAX1');
    };

    person.getTax3 = function() {
        return getLegalIDListItem('TAX3');
    };

    person.getVAT = function() {
        return getLegalIDListItem('VAT');
    };

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    /**
     * Gets legalIds from list of legalIDs
     * @param {Object} item
     * @return {*}
     */
    function getLegalIDListItem(item) {
        var legalIDItem;

        for (var i = 0; i < legalIDs.length; i++) {
            if (legalIDs[i].type === item) {
                legalIDItem = legalIDs[i];
                break;
            }
        }

        return legalIDItem;
    }

    return person;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/person.js
// module id = 33
// module chunks = 0